import CategoryItem from '@src/components/category/CategoryItem';
import { getAllCategories } from '@src/redux/actions';
import React from 'react';

const Categories = ({ categories }) => {
	return (
		<div className="page all-categories">
			<div className="container">
				<div className="header">
					<h1>All Categories</h1>
				</div>

				<div className="body">
					{categories &&
						categories
							.filter(category => {
								return category.parentCategoryId === 0 && category.includeInTopMenu === true;
							})
							.map((parent, i) => (
								<div key={i} className="category-section">
									<h6>{parent.name}</h6>
									<div className="category-items-container">
										{categories
											.filter(
												category =>
													category.parentCategoryId === parent.id &&
													category.includeInTopMenu === true
											)
											.map((item, index) => (
												<div className="category-item-container" key={index}>
													<CategoryItem category={item} />
												</div>
											))}
									</div>
								</div>
							))}
				</div>
			</div>
		</div>
	);
};

export async function getStaticProps() {
	const categories = await getAllCategories();

	return {
		props: {
			categories,
		},
	};
}

export default Categories;
